import countryRoute from "features/country/routes.tsx";
import industryRoute from "features/industry/routes.tsx";
import functionalAreaRoute from "features/functionalArea/routes.tsx";
import skillRoute from "features/skill/routes.tsx";
import sliderRoute from "features/slider/routes.tsx";
// import chapterRoute from "features/chapter/routes.tsx";
// import classificationRoute from "features/classification/routes.tsx";
import courseRoute from "features/course/routes.tsx";
import instituteRoute from "features/institute/routes.tsx";
import memberRoute from "features/member/routes.tsx";
import programRoute from "features/program/routes.tsx";
import specializationRoute from "features/specialization/routes.tsx";
import courseSpecializationRoute from "features/courseSpecialization/routes.tsx";
import securityRoutes from "features/security/routes";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import DashboardLayout from "layout/Dashboard/index2";
import LoginRoutes from "./LoginRoutes";
import ErrorBoundary from "./ErrorBoundary";
import testimonialRoute from "features/testimonial/routes.tsx";
import newsRoute from "features/news/routes.tsx";
import newsCategoryRoute from "features/newsCategory/routes.tsx";
import eventsRoute from "features/events/routes";
// import eventRegistrationRoute from "features/eventRegistration/routes";
import jobPostingRoute from "features/jobPosting/routes";
import achievementRoute from "features/achievement/routes";
import pageRoute from "features/page/routes";
import pageSectionRoute from "features/pageSection/routes";
import galleryImageRoute from "features/galleryImage/routes";
// import communityRoute from "features/security/routes";
import communityRoute from "features/community/routes";
import dashboardRoute from "features/dashboard/routes";
import demoRoute from "features/Demo/routes";
import emailTemplateRoute from "features/EmailTemplate/routes";
import campaignRoute from "features/campaign/routes";
import prominentMember from "features/prominentMember/routes";
import universityRoute from "features/university/routes";

const router = createBrowserRouter([
  {
    path: "/",
    element: <DashboardLayout />,
    errorElement: <ErrorBoundary />,
    children: [
      countryRoute,
      industryRoute,
      functionalAreaRoute,
      skillRoute,
      sliderRoute,
      newsRoute,
      newsCategoryRoute,
      courseRoute,
      instituteRoute,
      memberRoute,
      programRoute,
      specializationRoute,
      courseSpecializationRoute,
      securityRoutes,
      testimonialRoute,
      eventsRoute,
      // eventRegistrationRoute,
      jobPostingRoute,
      achievementRoute,
      pageRoute,
      pageSectionRoute,
      galleryImageRoute,
      dashboardRoute,
      demoRoute,
      emailTemplateRoute,
      campaignRoute,
      communityRoute,
      prominentMember,
      universityRoute,
    ],
  },
  LoginRoutes,
]);

export default function Router() {
  return <RouterProvider router={router} />;
}
